import { TestTube2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import {
  Empty,
  EmptyContent,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty'
import type { PackagingSvhcAuditStoredEntry } from '@/shared/hooks/api/packagingSuppliers'
import { PackagingSvhcAuditHistoryTable } from './PackagingSvhcAuditHistoryTable'

type PackagingItemSvhcAuditTabProps = {
  history: PackagingSvhcAuditStoredEntry[]
  locale: string
  showRunAudit?: boolean
  onRunAuditClick?: () => void
  showManualOverride?: boolean
  onManualOverrideClick?: () => void
}

export function PackagingItemSvhcAuditTab({
  history,
  locale,
  showRunAudit = false,
  onRunAuditClick,
  showManualOverride = false,
  onManualOverrideClick,
}: PackagingItemSvhcAuditTabProps) {
  const { t } = useTranslation('packagingSuppliers')
  const showRun = showRunAudit && onRunAuditClick
  const showOverride = showManualOverride && onManualOverrideClick
  const hasHistory = history.length > 0

  if (!hasHistory) {
    return (
      <div className='space-y-4'>
        {showRun ? (
          <Alert variant='info'>
            <AlertDescription>
              {t('itemDetail.svhcAudit.runHint')}
            </AlertDescription>
          </Alert>
        ) : null}
        <Empty className='rounded-lg border border-dashed py-12'>
          <EmptyHeader>
            <EmptyMedia variant='icon'>
              <TestTube2 className='size-10' />
            </EmptyMedia>
            <EmptyTitle>{t('itemDetail.svhcAudit.empty')}</EmptyTitle>
          </EmptyHeader>
          {showRun || showOverride ? (
            <EmptyContent>
              <div className='flex flex-wrap justify-center gap-3'>
                {showOverride ? (
                  <Button type='button' variant='outline' onClick={onManualOverrideClick}>
                    {t('itemDetail.manualOverride.button')}
                  </Button>
                ) : null}
                {showRun ? (
                  <Button type='button' onClick={onRunAuditClick}>
                    {t('itemDetail.svhcAudit.run')}
                  </Button>
                ) : null}
              </div>
            </EmptyContent>
          ) : null}
        </Empty>
      </div>
    )
  }

  return (
    <div className='space-y-4'>
      {showRun ? (
        <Alert variant='info'>
          <AlertDescription>{t('itemDetail.svhcAudit.runHint')}</AlertDescription>
        </Alert>
      ) : null}
      {showRun || showOverride ? (
        <div className='flex flex-wrap justify-end gap-3'>
          {showOverride ? (
            <Button type='button' variant='outline' onClick={onManualOverrideClick}>
              {t('itemDetail.manualOverride.button')}
            </Button>
          ) : null}
          {showRun ? (
            <Button type='button' variant='outline' onClick={onRunAuditClick}>
              {t('itemDetail.svhcAudit.run')}
            </Button>
          ) : null}
        </div>
      ) : null}
      <PackagingSvhcAuditHistoryTable history={history} locale={locale} />
    </div>
  )
}
